// removed by extract-text-webpack-plugin
module.exports = {"input":"controls-module__input___3dQuX","label":"controls-module__label___GcBvb","button":"controls-module__button___2MgCt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/controls.module.scss
// module id = 451
// module chunks = 0